import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const getHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`,
  },
});

// CRUD for a lead's additional email addresses (mirrors leadPhoneService.js).
// The primary address mirrors Leads.email and is managed on the lead record —
// the API refuses to edit or delete it here.
export const getLeadEmails = (leadId) =>
  axios.get(`${API_URL}/leads/${leadId}/email-addresses`, getHeaders());

export const createLeadEmail = (leadId, data) =>
  axios.post(`${API_URL}/leads/${leadId}/email-addresses`, data, getHeaders());

export const updateLeadEmail = (leadId, emailId, data) =>
  axios.put(`${API_URL}/leads/${leadId}/email-addresses/${emailId}`, data, getHeaders());

export const deleteLeadEmail = (leadId, emailId) =>
  axios.delete(`${API_URL}/leads/${leadId}/email-addresses/${emailId}`, getHeaders());
